import { Donation } from '../../types/DonationTypes';

export type HistoryDetail =
  | { text: string; translationKey?: never; defaultValue?: never }
  | { text?: never; translationKey: string; defaultValue: string };

export const getSentHistoryTypeTranslationKey = (item: Donation): string => {
  switch (item.historyType) {
    case 'avatarShapePurchase':
      return 'manage:zem_history_type_avatar_shape_purchase';
    case 'equipmentPurchase':
      return 'manage:zem_history_type_equipment_purchase';
    default:
      return 'manage:zem_history_type_gift';
  }
};

export const getSentHistoryDetail = (item: Donation): HistoryDetail => {
  if (!item.historyType || item.historyType === 'donation') {
    return { text: item.targetPlayerName || '-' };
  }

  const sku = item.itemSku?.trim();
  if (!sku || !item.itemType) return { text: '-' };

  return {
    translationKey: `wearables:${item.itemType}.${sku}.name`,
    defaultValue: sku,
  };
};
